import { Box } from "@mui/material";
import styled from "styled-components";

export const Content = styled(Box)`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  width: 620px;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 20px;
`;

export const Form = styled.form`
  margin-top: 15px;
`;

export const ActionsContainer = styled.div`
  margin-top: 35px;
  display: flex;
  justify-content: flex-end;

  > button:first-child {
    margin-right: 10px;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;

  div:first-child {
    margin-left: 0px;
  }
`;

export const ViewData = styled(Box)`
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export const ContainerButton = styled.div`
  display: flex;
  gap: 10px;
`;

export const Instructions = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;
